import Layout from "../common/layout";
import Partners from "../components/partners";
import Convert from "../components/convert";
import Wastes from "../components/wastes";
import WasteMethods from "../components/methods";
import MobileApp from "../components/mobileApp";
import FaqsComponent from "../components/faqs";
import Testimonials from "../components/testimonials";
import WhyUs from "../components/whyus";
import Products from "../components/Product";
import PricingSection from "../components/PricingSection";
import { ButtonComponent } from "../components/Tags/button";
import { useState, useEffect, useContext } from "react";
import { ParagraphComponent } from "../components/Tags/paragraph";
import { ImageComponent } from "../components/Tags/image";
import { useNavigate } from "react-router";
import { Context, getUser } from "../context/UserDetails";

import service1 from "../assets/hero1.jpg";
import service2 from "../assets/hero6.jpg";
import service3 from "../assets/hero3.jpg";
import service4 from "../assets/hero4.jpg";
import service5 from "../assets/hero5.jpg";

const heroImages = [service4, service1, service2, service3, service5];

const SectionComponent = () => {
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);
  
  const handleSellWaste = () => {
    navigate("/login");
  };
  
  const handleBuyProducts = () => {
    window.open("https://api.whatsapp.com/send?phone=2348038551338&text=Hi!%20Welcome%20to%20GJC%20recycling.%20%0AHow%20can%20I%20help%20you", "_blank");
  };


  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % heroImages.length);
    }, 3000);
    
    return () => clearInterval(interval);
  }, []);

  const goToPrevious = () => {
    setCurrentIndex((prev) => 
      prev === 0 ? heroImages.length - 1 : prev - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev + 1) % heroImages.length);
  };

  return (
    <div className="header w-full" style={{
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      width: '100%'
    }}>
      <section className="grid md:grid-cols-2 grid-cols-1 gap-6 items-center p-3 max-w-5xl justify-between mx-auto min-h-[80vh]">
        <div className="max-w-xl">
          <h1 className="text-4xl md:text-5xl font-gsans-bold capitalize tracking-wider text-shadow font-bold text-light leading-tight">
            Turn Waste into Wealth with GJC Recycling
          </h1>

          <ParagraphComponent
            text="We buy plastic waste from Ibadan suppliers and sell premium recycled materials to manufacturers nationwide."
            type="light"
            _style="mt-4 text-lg"
          />
          
          <div className="flex flex-wrap gap-4 mt-6">
            <button
              onClick={handleSellWaste}
              className="px-6 py-3 bg-green-600 hover:bg-green-700 text-white font-bold rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg flex items-center gap-2"
            >
              <span></span> Sell Your Waste
            </button>
            <button
              onClick={handleBuyProducts}
              className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg flex items-center gap-2"
            >
              <span></span> Buy Recycled Products
            </button>
          </div>
          
          <div className="mt-6 flex flex-wrap gap-2">
            <span className="bg-green-500/20 backdrop-blur-sm px-3 py-1.5 rounded-full text-sm text-light border border-green-500/30">
               Ibadan, Oyo State
            </span>
            <span className="bg-blue-500/20 backdrop-blur-sm px-3 py-1.5 rounded-full text-sm text-light border border-blue-500/30">
               Nationwide Delivery
            </span>
            <span className="bg-yellow-500/20 backdrop-blur-sm px-3 py-1.5 rounded-full text-sm text-light border border-yellow-500/30">
              ⭐ Since 2020
            </span>
            <span className="bg-purple-500/20 backdrop-blur-sm px-3 py-1.5 rounded-full text-sm text-light border border-purple-500/30">
              🤝 500+ Happy Clients
            </span>
          </div>
          
          <div className="mt-6 grid grid-cols-3 gap-4 bg-white/5 backdrop-blur-sm rounded-lg p-4 border border-white/10">
            <div className="text-center">
              <p className="text-2xl font-bold text-green-400">5000+</p>
              <p className="text-xs text-light/70">Tons Collected</p>
            </div>
            <div className="text-center">
              <p className="text-2xl font-bold text-blue-400">50+</p>
              <p className="text-xs text-light/70">Manufacturers</p>
            </div>
            <div className="text-center">
              <p className="text-2xl font-bold text-yellow-400">100%</p>
              <p className="text-xs text-light/70">Recycled</p>
            </div>
          </div>
        </div>
        
   
        <div className="relative">
       
          <div className="relative rounded-2xl overflow-hidden">
            <ImageComponent 
              _style="md:w-[27rem] w-full h-72 rounded-2xl object-cover transition-opacity duration-500" 
              src={heroImages[currentIndex]} 
            />
            
            {/* Navigation dots */}
            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2">
              {heroImages.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`w-2 h-2 rounded-full transition-all duration-300 ${
                    index === currentIndex 
                      ? 'bg-white w-6' 
                      : 'bg-white/50 hover:bg-white/80'
                  }`}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
            
            {/* Previous button */}
            <button
              onClick={goToPrevious}
              className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-black/30 hover:bg-black/50 text-white rounded-full p-2 transition-all duration-300"
              aria-label="Previous image"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            
            {/* Next button */}
            <button
              onClick={goToNext}
              className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-black/30 hover:bg-black/50 text-white rounded-full p-2 transition-all duration-300"
              aria-label="Next image"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

const HomePage = (): JSX.Element => {
  const [loggedIn] = useState<Boolean>(getUser().loggedIn || false);
  const contextValue = useContext(Context);
  const { items } = contextValue;
  const navigate = useNavigate();
  
  useEffect(() => {
    if (loggedIn) {
      navigate("/dashboard");
    }
  }, []);

  return (
    <>
      {!loggedIn && (
        <Layout name="Home" SectionComponent={SectionComponent}>
          <Convert />
          <Wastes items={items} />
          <Products />
          <PricingSection />
          <WasteMethods />
          <Partners />
          <MobileApp />
          <FaqsComponent />
          <Testimonials />
          <WhyUs />
        </Layout>
      )}
    </>
  );
};

export default HomePage;